// extracted by mini-css-extract-plugin
export default {"container":"studentComments_container__gq2Xc","content":"studentComments_content__Torqr","count":"studentComments_count__+04pW","loader":"studentComments_loader__+xsnn"};